// removed by extract-text-webpack-plugin
module.exports = {"dataCubeRow":"data-cube-row-module__dataCubeRow___cR7hK","cubesDoubleRowWrapper":"data-cube-row-module__cubesDoubleRowWrapper___2l_WC","dataCubeRowTitle":"data-cube-row-module__dataCubeRowTitle___3JaZE","dataCubeRowWrapper":"data-cube-row-module__dataCubeRowWrapper___HelSS","cubesDoubleRowComparing":"data-cube-row-module__cubesDoubleRowComparing___2hvPV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/data-cube-row/data-cube-row.module.scss
// module id = 877
// module chunks = 0 1